import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PrimeTemplate } from 'primeng/api';
import { UiPageTitleModule, UiUtilModule } from 'ui-shared';
import { HrHistorySplitButtonComponent } from './hr-history-split-button.component';
import { SplitButtonModule } from 'primeng/splitbutton';
import { TableModule } from 'primeng/table';
import { MenuModule } from 'primeng/menu';

@NgModule({
    declarations: [HrHistorySplitButtonComponent],
    imports: [CommonModule, TranslateModule, PrimeTemplate, UiUtilModule, TableModule, UiPageTitleModule, SplitButtonModule, MenuModule],
    exports: [HrHistorySplitButtonComponent],
})
export class HrHistorySplitButtonModule {}
